import withCheckRadioHookForm from '../hoc/withCheckRadioHookForm';
import Checkbox from './Checkbox';

const CheckboxWithHookForm = withCheckRadioHookForm(Checkbox);

export default CheckboxWithHookForm;
